"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "form",
      { action: "your-server-side-code", method: "POST" },
      _react2.default.createElement("script", {
        src: "https://checkout.stripe.com/checkout.js", "class": "stripe-button",
        "data-key": "pk_test_OMXy585qFY32U1hTg8BCV3Lx",
        "data-amount": "999",
        "data-name": "Fisherman Technologies, Inc.",
        "data-description": "Widget",
        "data-image": "https://stripe.com/img/documentation/checkout/marketplace.png",
        "data-locale": "auto" })
    )
  );
};